import "./AllNotifications.css";
import React, { Fragment } from "react";
import TodayNotificationComponent from "./TodayNotificationComponent/TodayNotificationComponent";
import YesterdayNotificationComponent from "./YesterdayNotificationComponent/YesterdayNotificationComponent";
import useTotalRealTimeNotifications from "./scripts/hook";
import { Link, useNavigate } from "react-router-dom";
// import useRealTimeNotifications from "../../components/Header/scripts/hook";
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';

const AllNotifications = () => {
  const navigate = useNavigate();
  const [
    AllRealTimeNotifications,
    TodayNotifications,
    setTodayNotifications,
    YesterdayNotifications,
    setYesterdayNotifications,
    setType,
  ] = useTotalRealTimeNotifications();

  return (
    <Fragment>
      <div className="global-body-container">
        <div className="notification-top-bar">
          <div className="mr-4 d-lg-block">
            <div class="mr-4">
            <button onClick={() => navigate(-1)} className="custom-back-btn">
                <ArrowBackIosRoundedIcon className="custom-back-btn-icon"/>
                  <span>Back</span>
                </button>
            </div>
          </div>

          <div
            className="mr-auto"
            style={{
              display: "flex",
              alignItems: "baseline",
            }}
          >
            <h2 className="text-black mb-0 notification-padding custom-heading">
              Notifications
            </h2>
            <select
              className="notification-select"
              onChange={(e) => setType(e.target.value)}
              name="notifications"
              id="notifications"
            >
              <option value="all">All</option>
              <option value="read">Read</option>
              <option value="un-read">Un Read</option>
            </select>
          </div>
        </div>

        <Fragment>
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                borderBottom: "1px solid #cccccc",
              }}
            ></div>

            <div
              className={`${
                AllRealTimeNotifications?.length === 0
                  ? "no-notifications-scroll"
                  : "scrollable-notifications-div"
              }`}
            >
              {AllRealTimeNotifications?.length === 0 && (
                <p className="user-no-notifications">No Notifications</p>
              )}
              <ul>
                {TodayNotifications &&
                  TodayNotifications.map((notification) => (
                    <Link
                      to={`/user/${notification.notification_link.substring(
                        29
                      )}`}
                    >
                      <TodayNotificationComponent
                        notification={notification}
                        TodayNotifications={TodayNotifications}
                        setTodayNotifications={setTodayNotifications}
                      />
                    </Link>
                  ))}
              </ul>
              <ul>
                {YesterdayNotifications &&
                  YesterdayNotifications.map((notification) => (
                    <Link
                      to={`/user/${notification.notification_link.substring(
                        29
                      )}`}
                    >
                      <YesterdayNotificationComponent
                        notification={notification}
                        YesterdayNotifications={YesterdayNotifications}
                        setYesterdayNotifications={setYesterdayNotifications}
                      />
                    </Link>
                  ))}
              </ul>
            </div>
            {AllRealTimeNotifications?.length !== 0 && (
              <span
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  margin: "20px 0px 0px 0px",
                }}
              >
                <button
                  style={{
                    backgroundColor: "#ffffff",
                    border: "1px solid",
                    borderRadius: "30px",
                    padding: "12px 30px 12px 30px",
                    fontSize: "14px",
                    fontWeight: 600,
                  }}
                >
                  Load More Notifications
                </button>
              </span>
            )}
          </div>
        </Fragment>
      </div>
    </Fragment>
  );
};

export default AllNotifications;
